import { HireImageSize } from '../../lib/view-models/vehicle';

export const getImageCropUrl = (rawImageUrl: string, cropName: HireImageSize): string => {
    return rawImageUrl.replace('{IMAGE-SIZE}', cropName);
};
